import useDates from "@/composables/useDates";

const {
    currentDate,
    startOfMonthDate,
    lastDayOfMonth
} = useDates()

export const moduleFields = {
    filter: {
      range: [startOfMonthDate(), lastDayOfMonth()],
      to: currentDate(),
      from: '',
      branch: ''
    },
    transaction: {
        code: '',
        reference_number: '',
        entry_date: currentDate(),
        transaction_date: currentDate(),
        supplier: '',
        purchaser: '',
        entries: [],
        branch: '',
        status: 'draft'
    },
    transaction_entry: {
        code: '',
        transaction_type: '',
        description: '',
        item_type: '',
        quantity: 1,
        mode_of_payment: '',
        entry_reference: '',
        amount: '',
        remarks: '',
    },
    petty_cash: {
        code: '',
        branch: '',
        date: '',
        amount: '',
        remarks: '',
        status: 1
    },
    item_types: {
        code: '',
        custom_code: '',
        name: '',
        description: '',
        parent: '',
        status: 1
    },
    branches: {
        code: '',
        custom_code: '',
        name: '',
        is_head_office: 0,
        status: 1
    },
    address:  {
        province: '',
        city: '',
        barangay: '',
        address: '',
        zip: ''
    },
    entities: {
        main: {
            code: '',
            custom_code: '',
            type: 'business',
            business_name: '',
            tin: '',
            email: '',
            is_same_as_billing: 0,
            status: 1
        },
        address:  {
            province: '',
            city: '',
            address: '',
            zip: '',
        },
        contact_person: {
            salutation: 'mr',
            first_name: '',
            last_name: '',
            email: '',
            contact_number: '',
            position: '',
            department: ''
        }
    },
    user: {
        user_name: '',
        custom_user_name: '',
        salutation: 'mr',
        first_name: '',
        middle_name: '',
        last_name: '',
        suffix: '',
        email: '',
        contact_no: '',
        gender: 'M',
        birthday: currentDate(),
        employee_id: '',
        branch: [],
        department: '',
        designation: '',
        employment_status: 1,
        status: 1
    },
    password: {
        current: '',
        new: '',
        confirm: ''
    },
    stocks: {
        code: '',
        date: currentDate(),
        invoice_no: '',
        branch: '',
        remarks: '',
        items: [],
        total_qty: 0,
        total_amount: 0
    },
    stock_items: {
        item: '',
        unit: '',
        quantity: '',
        multiplier: '',
        cost: '',
        total: ''
    },
    waste: {
        date: currentDate(),
        branch: '',
        total_qty: 0,
    },
    waste_items: {
        code: '',
        date: currentDate(),
        branch: '',
        item: '',
        unit: 'UNT_PCS',
        quantity: '',
        remarks: '',
        file: []
    },
    recipe: {
        code: '',
        description: '',
        remarks: '',
        ingredients: [],
        unit: '',
        content: '',
        amount: '',
        str_cost_of_goods: '',
        cost_of_goods: '',
        cost_of_goods_percent: '',
        is_mixture: 0,
        status: 1
    },
    ingredients: {
        code: '',
        unit: '',
        qty: ''
    },
    permissions: {
        acctg_sys: {
            type: 'sys',
            access: 0, disabled: 0,
            modules: {
                accounting: {
                    type: 'page',
                    access: 1, disabled: 0,
                    modules:  {
                        'journal': {
                            code: 'journal',
                            name: 'Journal',
                            func: [
                                {code: 'view', text: 'View vouchers', access: 1, disabled: 0},
                                {code: 'create', text: 'Create new vouchers', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify vouchers', access: 0, disabled: 0},
                                {code: 'post', text: 'Post vouchers', access: 0, disabled: 0},
                                {code: 'delete', text: 'Delete vouchers', access: 0, disabled: 0},
                                // {code: 'reverse', text: 'Reverse', access: 0, disabled: 0},
                            ]
                        },
                        'payable': {
                            code: 'payable',
                            name: 'Payables',
                            func: [
                                {code: 'view', text: 'View vouchers', access: 1, disabled: 0},
                                {code: 'create', text: 'Create new vouchers', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify vouchers', access: 0, disabled: 0},
                                {code: 'post', text: 'Post vouchers', access: 0, disabled: 0},
                                {code: 'delete', text: 'Delete vouchers', access: 0, disabled: 0},
                                // {code: 'reverse', text: 'Reverse', access: 0, disabled: 0},
                            ]
                        },
                        'receivables': {
                            code: 'receivables',
                            name: 'Receivables',
                            func: [
                                {code: 'view', text: 'View vouchers', access: 1, disabled: 0},
                                {code: 'create', text: 'Create new vouchers', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify vouchers', access: 0, disabled: 0},
                                {code: 'post', text: 'Post vouchers', access: 0, disabled: 0},
                                {code: 'delete', text: 'Delete vouchers', access: 0, disabled: 0},
                                // {code: 'reverse', text: 'Reverse', access: 0, disabled: 0},
                            ]
                        },

                        'payments': {
                            code: 'payments',
                            name: 'Payments',
                            func: [
                                {code: 'view', text: 'View vouchers', access: 1, disabled: 0},
                                {code: 'create', text: 'Create new vouchers', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify vouchers', access: 0, disabled: 0},
                                {code: 'post', text: 'Post vouchers', access: 0, disabled: 0},
                                {code: 'delete', text: 'Delete vouchers', access: 0, disabled: 0},
                                // {code: 'reverse', text: 'Reverse', access: 0, disabled: 0},
                            ]
                        },

                        'receipts': {
                            code: 'receipts',
                            name: 'Receipts',
                            func: [
                                {code: 'view', text: 'View vouchers', access: 1, disabled: 0},
                                {code: 'create', text: 'Create new vouchers', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify vouchers', access: 0, disabled: 0},
                                {code: 'post', text: 'Post vouchers', access: 0, disabled: 0},
                                {code: 'delete', text: 'Delete vouchers', access: 0, disabled: 0},
                                // {code: 'reverse', text: 'Reverse', access: 0, disabled: 0},
                            ]
                        }
                    }
                },
                reports: {
                    type: 'page',
                    access: 1, disabled: 0,
                    modules:  {
                        'trial_balance': {
                            code: 'trial_balance',
                            name: 'Trial Balance',
                            func: [
                                {code: 'view', text: 'View report', access: 1, disabled: 0},
                                {code: 'export', text: 'Export report', access: 1, disabled: 0},
                                // {code: 'reverse', text: 'Reverse', access: 0, disabled: 0},
                            ]
                        },
                        'balance_sheet': {
                            code: 'balance_sheet',
                            name: 'Balance Sheet',
                            func: [
                                {code: 'view', text: 'View report', access: 1, disabled: 0},
                                {code: 'export', text: 'Export report', access: 1, disabled: 0},
                                // {code: 'reverse', text: 'Reverse', access: 0, disabled: 0},
                            ]
                        },
                        'profit_loss': {
                            code: 'profit_loss',
                            name: 'Profit and Loss',
                            func: [
                                {code: 'view', text: 'View report', access: 1, disabled: 0},
                                {code: 'export', text: 'Export report', access: 1, disabled: 0},
                                // {code: 'reverse', text: 'Reverse', access: 0, disabled: 0},
                            ]
                        },
                    }
                },
                setup: {
                    type: 'page',
                    access: 1, disabled: 0,
                    modules:  {
                        'entities': {
                            code: 'entities',
                            name: 'Entities',
                            func: [
                                {code: 'view', text: 'View entities', access: 1, disabled: 0},
                                {code: 'create', text: 'Create entities', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify entities', access: 0, disabled: 0},
                                {code: 'delete', text: 'Delete entities', access: 0, disabled: 0},
                            ]
                        },
                        'branches': {
                            code: 'branches',
                            name: 'Branches',
                            func: [
                                {code: 'view', text: 'View branches', access: 1, disabled: 0},
                                {code: 'create', text: 'Create branches', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify branches', access: 0, disabled: 0},
                                {code: 'delete', text: 'Delete branches', access: 0, disabled: 0},
                            ]
                        },
                        'chart_of_accounts': {
                            code: 'chart_of_accounts',
                            name: 'Chart of Accounts',
                            func: [
                                {code: 'view', text: 'View chart of accounts', access: 1, disabled: 0},
                                {code: 'create', text: 'Create chart of accounts', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify chart of accounts', access: 0, disabled: 0},
                                {code: 'delete', text: 'Delete chart of accounts', access: 0, disabled: 0},
                            ]
                        },
                        'account_mapping': {
                            code: 'account_mapping',
                            name: 'Account Mapping',
                            func: [
                                {code: 'view', text: 'View mapping', access: 1, disabled: 0},
                                {code: 'create', text: 'Create mapping', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify mapping', access: 0, disabled: 0},
                                {code: 'delete', text: 'Delete mapping', access: 0, disabled: 0},
                            ]
                        },
                        'users': {
                            code: 'users',
                            name: 'Users',
                            func: [
                                {code: 'view', text: 'View users', access: 1, disabled: 0},
                                {code: 'create', text: 'Create users', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify user', access: 0, disabled: 0},
                                {code: 'delete', text: 'Remove user', access: 0, disabled: 0},
                                {code: 'reset', text: 'Reset user password', access: 0, disabled: 0},
                                {code: 'modify_perms', text: 'Modify user permission', access: 0, disabled: 0},
                            ]
                        },
                    }
                }
            }
        },
        opt_sys: {
            type: 'sys',
            access: 1, disabled: 0,
            modules: {
                pages: {
                    type: 'page',
                    access: 1, disabled: 0,
                    modules: {
                        sales_transactions: {
                            code: 'sales_transactions',
                            name: 'Sales Transactions',
                            func: [
                                {code: 'view', text: 'View transactions', access: 1, disabled: 0},
                                {code: 'import', text: 'Import sales', access: 0, disabled: 0},
                                {code: 'delete', text: 'Delete uploaded sales', access: 0, disabled: 0},
                                // {code: 'reverse', text: 'Reverse', access: 0, disabled: 0},
                            ]
                        },
                        transactions: {
                            code: 'transactions',
                            name: 'Transactions',
                            func: [
                                {code: 'view', text: 'View transactions', access: 1, disabled: 0},
                                {code: 'create', text: 'Create new transactions', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify transactions', access: 0, disabled: 0},
                                {code: 'post', text: 'Post transactions', access: 0, disabled: 0},
                                {code: 'delete', text: 'Delete transactions', access: 0, disabled: 0},
                                // {code: 'reverse', text: 'Reverse', access: 0, disabled: 0},
                            ]
                        },
                        petty_cash: {
                            code: 'petty_cash',
                            name: 'Petty Cash',
                            func: [
                                {code: 'view', text: 'View transactions', access: 1, disabled: 0},
                                {code: 'create', text: 'Add transactions', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify transactions', access: 0, disabled: 0},
                            ]
                        },
                        stocks: {
                            code: 'stocks',
                            name: 'Stocks',
                            func: [
                                {code: 'view', text: 'View stocks', access: 1, disabled: 0},
                                {code: 'create', text: 'Add stocks', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify stocks', access: 0, disabled: 0},
                                {code: 'delete', text: 'Remove stocks', access: 0, disabled: 0},
                            ]
                        },
                        waste: {
                            code: 'waste',
                            name: 'Waste',
                            func: [
                                {code: 'view', text: 'View waste', access: 1, disabled: 0},
                                {code: 'create', text: 'Add waste', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify waste', access: 0, disabled: 0},
                                {code: 'delete', text: 'Remove waste', access: 0, disabled: 0},
                            ]
                        }
                    }
                },
                reports: {
                    type: 'page',
                    access: 1, disabled: 0,
                    modules:  {
                        'sales': {
                            code: 'sales',
                            name: 'Sales',
                            func: [
                                {code: 'view', text: 'View report', access: 1, disabled: 0},
                                {code: 'export', text: 'Export report', access: 1, disabled: 0},
                                // {code: 'reverse', text: 'Reverse', access: 0, disabled: 0},
                            ]
                        },
                        'inventory': {
                            code: 'inventory',
                            name: 'Inventory',
                            func: [
                                {code: 'view', text: 'View report', access: 1, disabled: 0},
                                {code: 'export', text: 'Export report', access: 1, disabled: 0},
                                // {code: 'reverse', text: 'Reverse', access: 0, disabled: 0},
                            ]
                        },
                        'transactions_report': {
                            code: 'transactions_report',
                            name: 'Transaction Reports',
                            func: [
                                {code: 'view', text: 'View report', access: 1, disabled: 0},
                                {code: 'export', text: 'Export report', access: 1, disabled: 0},
                                // {code: 'reverse', text: 'Reverse', access: 0, disabled: 0},
                            ]
                        },
                        'daily': {
                            code: 'daily',
                            name: 'Daily Reports',
                            func: [
                                {code: 'view', text: 'View report', access: 1, disabled: 0},
                                {code: 'export', text: 'Export report', access: 1, disabled: 0},
                                {code: 'post', text: 'Post daily report', access: 0, disabled: 0},
                                {code: 'unpost', text: 'Unpost daily report', access: 0, disabled: 0},
                                // {code: 'reverse', text: 'Reverse', access: 0, disabled: 0},
                            ]
                        },

                    }
                },
                setup: {
                    type: 'page',
                    access: 1, disabled: 0,
                    modules:  {
                        'entities': {
                            code: 'entities',
                            name: 'Entities',
                            func: [
                                {code: 'view', text: 'View entities', access: 1, disabled: 0},
                                {code: 'create', text: 'Create entities', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify entities', access: 0, disabled: 0},
                                {code: 'delete', text: 'Delete entities', access: 0, disabled: 0},
                            ]
                        },
                        'recipe': {
                            code: 'recipe',
                            name: 'Item Recipes',
                            func: [
                                {code: 'view', text: 'View recipes', access: 1, disabled: 0},
                                {code: 'create', text: 'Create recipes', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify recipes', access: 0, disabled: 0},
                                {code: 'delete', text: 'Delete recipes', access: 0, disabled: 0},
                            ]
                        },
                        'supply_category': {
                            code: 'supply_category',
                            name: 'Supply Category',
                            func: [
                                {code: 'view', text: 'View categories', access: 1, disabled: 0},
                                {code: 'create', text: 'Create categories', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify categories', access: 0, disabled: 0},
                                {code: 'delete', text: 'Delete categories', access: 0, disabled: 0},
                            ]
                        },
                        'supply_types': {
                            code: 'supply_types',
                            name: 'Supply Types',
                            func: [
                                {code: 'view', text: 'View supply types', access: 1, disabled: 0},
                                {code: 'create', text: 'Create supply types', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify supply types', access: 0, disabled: 0},
                                {code: 'delete', text: 'Delete supply types', access: 0, disabled: 0},
                            ]
                        },
                        'items': {
                            code: 'items',
                            name: 'Items',
                            func: [
                                {code: 'view', text: 'View items', access: 1, disabled: 0},
                                {code: 'create', text: 'Create items', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify items', access: 0, disabled: 0},
                                {code: 'delete', text: 'Delete items', access: 0, disabled: 0},
                            ]
                        },
                        'users': {
                            code: 'users',
                            name: 'Users',
                            func: [
                                {code: 'view', text: 'View users', access: 1, disabled: 0},
                                {code: 'create', text: 'Add users', access: 0, disabled: 0},
                                {code: 'update', text: 'Modify user details', access: 0, disabled: 0},
                                {code: 'delete', text: 'Remove user', access: 0, disabled: 0},
                                {code: 'reset', text: 'Reset user password', access: 0, disabled: 0},
                                {code: 'permission', text: 'Modify user permission', access: 0, disabled: 0},
                                {code: 'branch_assignment', text: 'Modify branch assignment', access: 0, disabled: 0},
                            ]
                        }
                    }
                }
            }
        }
    }
}